import { b1, b2, b3, b4 } from "../img/img"


export const banners = [
    {
        id: 1,
        title: "We Will Solve Your Issues, Our Vision for Your Future",
        content: "We understand the challenges you face. Every problem, big or small, requires a solution that not only fixes the present but also secures a better future.",
        backgroundImage: b1,
        classNameTitle: " animate__flipInX",
        classNameContent: "animate__fadeInDown",
        btn: " animate__fadeInDown	",
    },
    {
        id: 2,
        title: "Embracing success do our best, need best advice",
        content: "Success doesn't happen by chance, it’s built on smart decisions, relentless effort, and expert guidance. ",
        backgroundImage: b2,
        classNameTitle: " animate__fadeInDown ",
        classNameContent: " animate__fadeInUp",
        btn: " animate__fadeInUp",


    },
    {
        id: 3,
        title: "Digital transformation driven by technology",
        content: "We understand that embracing digital change is not just about adopting the latest tools, it’s about fundamentally rethinking how you operate and deliver value.",
        backgroundImage: b3,
        classNameTitle: " animate__flipInY ",
        classNameContent: " animate__fadeInDown",
        btn: "animate__fadeInDown",


    },
    {
        id: 4,
        title: "For those who believe in leaving a mark",
        content: "Success is not merely measured by profits but by the impact you have on your community, industry, and the world.",
        backgroundImage: b4,
        classNameTitle: "  animate__fadeInUp ",
        classNameContent: " animate__fadeInUp",
        btn: " animate__fadeInDown ",
    }
];